import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faUser } from '@fortawesome/pro-solid-svg-icons';

import AddContactOption from './add_contact';
import isPerson from './is_person';

// Copied to ./contact_and_database.js (plus database rendering) rather than using a prop because we don't
// have control over props
const ContactOption = (props) => {
  const { data, innerProps, innerRef, label } = props;

  if (data.type === 'addContact') return <AddContactOption {...props} />;

  if (data.type === 'addCompany') return <AddContactOption company {...props} />;

  return (
    <div ref={innerRef} {...innerProps} className="entity">
      <FontAwesomeIcon
        className="type-icon"
        icon={isPerson(data) ? faUser : faBriefcase}
        pull="left"
        size="lg"
      />

      <div>
        <div>
          <strong>{label}</strong>
        </div>
      </div>
    </div>
  );
};

ContactOption.propTypes = {
  data: PropTypes.shape({
    person: PropTypes.bool,
    type: PropTypes.string
  }).isRequired,
  innerProps: PropTypes.object,
  innerRef: PropTypes.object,
  label: PropTypes.string.isRequired
};

export default ContactOption;
